import { Text } from '@awazevr/design-system.components.text';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Check } from '@awazevr/design-system.components.icon';
import {
  TextWithMargin,
  StyledIconAndHeader,
  StyledButton,
} from './ThankYouPage.styles';
import { Container } from '@/components/__UI';
import { getCookies } from '@/helpers/cookies'

export default function ThankYouPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isWebview = navigator.userAgent.includes('awz-owner-wv')
  const isIframe = getCookies('awz-iframe') === 'true'

  return (
    <Container>
      <StyledIconAndHeader>
        <Check
          backgroundColour="ColorStatusConstructive500"
          iconColour="ColorWhiteOpacity100"
          size="x-small"
        />
        <TextWithMargin type="bold">
          {t('thankYouYourSelectionConfirmed')}
        </TextWithMargin>
      </StyledIconAndHeader>
      <Text mb={32}>{t('weWillUpdateAcceptedPrices')}</Text>
      {!isWebview && !isIframe ? (
        <StyledButton
          onClick={() => navigate('/bookings/calendar')}
          text={t('goToTheCalendar')}
          colourScheme="brand-primary"
        />
      ) : (
        <></>
      )}
    </Container>
  );
}
